'use client'
import * as React from 'react'

import { ShareOption } from './share-item'
import { HeartIcon } from '@web/components/icons/heart'
import { useLikeProduct } from '@web/hooks/use-product-like-actions'
import { ErrorBoundaryWrapper } from '../error-boundary'

interface LikeButtonProps {
  productId: string
}

export function LikeButton({ productId }: LikeButtonProps) {
  const { onClick, isLiked, isLoading } = useLikeProduct(productId)

  return (
    <ErrorBoundaryWrapper>
      <ShareOption
        key={productId}
        onClick={onClick}
        title="Add to Favorites"
        disabled={isLoading}
        className="group"
        icon={<HeartIcon isFavorite={isLiked} className="size-6 text-[#E21743]" />}
      />
    </ErrorBoundaryWrapper>
  )
}
